import { createContext } from 'react';
import { OrganizationContextValue } from './types';

export const OrganizationContext = createContext<OrganizationContextValue | null>(null);